<template>
<div>

	<!-- Begin Title Bar -->
	<v-toolbar tile elevation="2">
		<v-toolbar-title>{{ $t('nav.marketplace') }}</v-toolbar-title>

		<v-spacer></v-spacer>

		<v-btn icon v-if="initializationDone" @click="$router.go(-1)">
			<v-icon class="color-green">mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="refresh">
			<v-icon class="color-green">mdi-refresh</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="showHelp = true">
			<v-icon class="color-green">mdi-help-circle</v-icon>
		</v-btn>
	</v-toolbar>
	<!-- End Title Bar -->

	<v-container>
	<Preloader v-show="!initializationDone" :text="$t('common.phrase.loading')" />


	<!-- Begin top dropdowns -->
	<v-sheet v-if="initializationDone" elevation="2" class="py-0 mb-4">
		<v-container>
			<v-row dense>
				<v-col class="text-center px-2 py-1">
					<!-- Begin popular trading pairs dropdown -->
					<PopularTradingPairList></PopularTradingPairList>
				</v-col>
				<v-col class="text-center px-2 py-1">
					<!-- Begin token pair watch list dropdown -->
					<TrackedTradingPairList
						show-add-new-token-pair-option
						v-on:tracked-token-pair-show-add-new="showAddNewTokenPairWatchForm1 = true"
					>
					</TrackedTradingPairList>
				</v-col>
			</v-row>
		</v-container>
	</v-sheet>
	<!-- End top dropdowns -->

	<!-- begin new token pair watch form -->
  <div v-if="initializationDone" class="mb-4"
    id="add-new-token-pair-watch-section" v-show="showAddNewTokenPairWatchForm1">
      <AddTokenPairWatchForm
        v-on:add-token-pair-watch-list-form-close="showAddNewTokenPairWatchForm1= false">
      </AddTokenPairWatchForm>
  </div>
  <!-- end new token pair watch form -->

	<v-sheet v-if="initializationDone" elevation="2" class="pt-0 px-3 pb-2 mb-4">
		<v-container>
			<div class="title mb-3">{{ $t('compOrdersByTokenPair.popularTradingPairs') }}:</div>
			<PopularTradingPairList type="chip" do-not-sort></PopularTradingPairList>
		</v-container>
	</v-sheet>

	<v-sheet v-if="initializationDone" elevation="2" class="pt-0 px-3 pb-2 mb-4">
		<v-container>
			<div class="title mb-3">{{ $t('compOrdersByTokenPair.myWatchlist') }}:</div>

			<TrackedTradingPairList class="mb-3"
				show-add-new-token-pair-option
				type="chip"
				v-on:tracked-token-pair-show-add-new="showAddNewTokenPairWatchForm = true"
			>
			</TrackedTradingPairList>

			<div class="mb-3 text-center">
				<v-btn color="secondary" :disabled="showAddNewTokenPairWatchForm2"
					@click="showAddNewTokenPairWatchForm2 = true"
				>
					{{ $t('compOrdersByTokenPair.addNewTradingPair') }}
				</v-btn>
			</div>

      <AddTokenPairWatchForm v-show="showAddNewTokenPairWatchForm2"
        v-on:add-token-pair-watch-list-form-close="showAddNewTokenPairWatchForm2 = false">
      </AddTokenPairWatchForm>

		</v-container>
	</v-sheet>

		<!-- Begin Help -->
		<v-bottom-sheet v-model="showHelp">

			<v-card tile>

				<!--Modal Title -->
				<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
					<v-toolbar-title><v-icon>mdi-help-circle</v-icon> {{ $t('nav.help') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="showHelp = false">
						<v-icon>mdi-window-close</v-icon>
					</v-btn>
				</v-toolbar>

				<!-- Modal Contents -->
				<v-card-text class="py-5 px-3" style="max-height: 400px; overflow-y: scroll;">
					<MarketplaceHelp class="mb-2"></MarketplaceHelp>
				</v-card-text>

			</v-card>

    </v-bottom-sheet>
    <!-- End Help -->


</v-container>
</div>
</template>

<script>

import { config } from '@/config'
import { BigNumber } from '@0x/utils'
import { Web3Wrapper } from '@0x/web3-wrapper'
import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import ERC20Token from "@/components/ERC20Token"
import { HttpClient } from '@0x/connect'
import BackButton from "@/components/BackButton"
import AddTokenPairWatchForm from "@/components/AddTokenPairWatchForm"
import ButtonLoading from "@/components/ButtonLoading"
import PopularTradingPairList from "@/components/PopularTradingPairList"
import TrackedTradingPairList from "@/components/TrackedTradingPairList"
import MarketplaceHelp from "@/components/help/MarketplaceHelp"

export default {
	name: 'Marketplace',
	components: {
		Preloader,
		BackButton,
		ERC20Token,
		MarketplaceHelp,
		AddTokenPairWatchForm,
		ButtonLoading,
		PopularTradingPairList,
		TrackedTradingPairList
	},
	data () {
		return {
			config: config,
			initializationDone: false,
			showHelp: false,
			showAddNewTokenPairWatchForm1: false,
			showAddNewTokenPairWatchForm2: false,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			myAddress: 'getUserAccount',
			tokenInfo: 'getTokenInfo',
			relayerList: 'getRelayerList',
			relayerInfo: 'getRelayerInfo',
			supportedERC20AssetPairsByRelayer: 'getSupportedERC20AssetPairsByRelayer',
			networkConfig: 'getNetworkConfig',
		}),
		isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'loadRelayerInfo']),

		/* ------------------------------------------------------ */
		async init () {
			this.initializationDone = false
			this.showAddNewTokenPairWatchForm1 = false
			this.showAddNewTokenPairWatchForm2 = false
			try {
				await this.loadNetwork()
				await this.loadTokenInfo()
				await this.loadAccount()
				console.log(this.account)
				await this.loadRelayerInfo()
				// console.log(this.relayerInfo)
			} catch (err) {
				console.log(err)
				this.$emit("errorNotification", this.$t('common.err.generic'))
			}

			this.initializationDone = true
		},

		async refresh () {
			this.init();
		},

	},
	created () {
		this.init()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
